(function () {
// src/components/details/details.styles.ts
/**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $cc4e6a48b379d1fe$var$t = globalThis, $cc4e6a48b379d1fe$export$b4d10f6001c083c2 = $cc4e6a48b379d1fe$var$t.ShadowRoot && (void 0 === $cc4e6a48b379d1fe$var$t.ShadyCSS || $cc4e6a48b379d1fe$var$t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, $cc4e6a48b379d1fe$var$s = Symbol(), $cc4e6a48b379d1fe$var$o = new WeakMap;
class $cc4e6a48b379d1fe$export$505d1e8739bad805 {
    constructor(t, e, o){
        if (this._$cssResult$ = !0, o !== $cc4e6a48b379d1fe$var$s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
        this.cssText = t, this.t = e;
    }
    get styleSheet() {
        let t = this.o;
        const s = this.t;
        if ($cc4e6a48b379d1fe$export$b4d10f6001c083c2 && void 0 === t) {
            const e = void 0 !== s && 1 === s.length;
            e && (t = $cc4e6a48b379d1fe$var$o.get(s)), void 0 === t && ((this.o = t = new CSSStyleSheet).replaceSync(this.cssText), e && $cc4e6a48b379d1fe$var$o.set(s, t));
        }
        return t;
    }
    toString() {
        return this.cssText;
    }
}
const $cc4e6a48b379d1fe$export$8d80f9cac07cdb3 = (t)=>new $cc4e6a48b379d1fe$export$505d1e8739bad805("string" == typeof t ? t : t + "", void 0, $cc4e6a48b379d1fe$var$s), $cc4e6a48b379d1fe$export$dbf350e5966cf602 = (t, ...e)=>{
    const o = 1 === t.length ? t[0] : e.reduce((e, s, o)=>e + ((t)=>{
            if (!0 === t._$cssResult$) return t.cssText;
            if ("number" == typeof t) return t;
            throw Error("Value passed to 'css' function must be a 'css' function result: " + t + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
        })(s) + t[o + 1], t[0]);
    return new $cc4e6a48b379d1fe$export$505d1e8739bad805(o, t, $cc4e6a48b379d1fe$var$s);
}, $cc4e6a48b379d1fe$export$2ca4a66ec4cecb90 = (s, o)=>{
    if ($cc4e6a48b379d1fe$export$b4d10f6001c083c2) s.adoptedStyleSheets = o.map((t)=>t instanceof CSSStyleSheet ? t : t.styleSheet);
    else for (const e of o){
        const o = document.createElement("style"), n = $cc4e6a48b379d1fe$var$t.litNonce;
        void 0 !== n && o.setAttribute("nonce", n), o.textContent = e.cssText, s.appendChild(o);
    }
}, $cc4e6a48b379d1fe$export$ee69dfd951e24778 = $cc4e6a48b379d1fe$export$b4d10f6001c083c2 ? (t)=>t : (t)=>t instanceof CSSStyleSheet ? ((t)=>{
        let e = "";
        for (const s of t.cssRules)e += s.cssText;
        return $cc4e6a48b379d1fe$export$8d80f9cac07cdb3(e);
    })(t) : t;


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: $58e0238934c743c8$var$i, defineProperty: $58e0238934c743c8$var$e, getOwnPropertyDescriptor: $58e0238934c743c8$var$h, getOwnPropertyNames: $58e0238934c743c8$var$r, getOwnPropertySymbols: $58e0238934c743c8$var$o, getPrototypeOf: $58e0238934c743c8$var$n } = Object, $58e0238934c743c8$var$a = globalThis, $58e0238934c743c8$var$c = $58e0238934c743c8$var$a.trustedTypes, $58e0238934c743c8$var$l = $58e0238934c743c8$var$c ? $58e0238934c743c8$var$c.emptyScript : "", $58e0238934c743c8$var$p = $58e0238934c743c8$var$a.reactiveElementPolyfillSupport, $58e0238934c743c8$var$d = (t, s)=>t, $58e0238934c743c8$export$7312b35fbf521afb = {
    toAttribute (t, s) {
        switch(s){
            case Boolean:
                t = t ? $58e0238934c743c8$var$l : null;
                break;
            case Object:
            case Array:
                t = null == t ? t : JSON.stringify(t);
        }
        return t;
    },
    fromAttribute (t, s) {
        let i = t;
        switch(s){
            case Boolean:
                i = null !== t;
                break;
            case Number:
                i = null === t ? null : Number(t);
                break;
            case Object:
            case Array:
                try {
                    i = JSON.parse(t);
                } catch (t) {
                    i = null;
                }
        }
        return i;
    }
}, $58e0238934c743c8$export$53a6892c50694894 = (t, s)=>!$58e0238934c743c8$var$i(t, s), $58e0238934c743c8$var$b = {
    attribute: !0,
    type: String,
    converter: $58e0238934c743c8$export$7312b35fbf521afb,
    reflect: !1,
    useDefault: !1,
    hasChanged: $58e0238934c743c8$export$53a6892c50694894
};
Symbol.metadata ??= Symbol("metadata"), $58e0238934c743c8$var$a.litPropertyMetadata ??= new WeakMap;
class $58e0238934c743c8$export$c7c07a37856565d extends HTMLElement {
    static addInitializer(t) {
        this._$Ei(), (this.l ??= []).push(t);
    }
    static get observedAttributes() {
        return this.finalize(), this._$Eh && [
            ...this._$Eh.keys()
        ];
    }
    static createProperty(t, s = $58e0238934c743c8$var$b) {
        if (s.state && (s.attribute = !1), this._$Ei(), this.prototype.hasOwnProperty(t) && ((s = Object.create(s)).wrapped = !0), this.elementProperties.set(t, s), !s.noAccessor) {
            const i = Symbol(), h = this.getPropertyDescriptor(t, i, s);
            void 0 !== h && $58e0238934c743c8$var$e(this.prototype, t, h);
        }
    }
    static getPropertyDescriptor(t, s, i) {
        const { get: e, set: r } = $58e0238934c743c8$var$h(this.prototype, t) ?? {
            get () {
                return this[s];
            },
            set (t) {
                this[s] = t;
            }
        };
        return {
            get: e,
            set (s) {
                const h = e?.call(this);
                r?.call(this, s), this.requestUpdate(t, h, i);
            },
            configurable: !0,
            enumerable: !0
        };
    }
    static getPropertyOptions(t) {
        return this.elementProperties.get(t) ?? $58e0238934c743c8$var$b;
    }
    static _$Ei() {
        if (this.hasOwnProperty($58e0238934c743c8$var$d("elementProperties"))) return;
        const t = $58e0238934c743c8$var$n(this);
        t.finalize(), void 0 !== t.l && (this.l = [
            ...t.l
        ]), this.elementProperties = new Map(t.elementProperties);
    }
    static finalize() {
        if (this.hasOwnProperty($58e0238934c743c8$var$d("finalized"))) return;
        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty($58e0238934c743c8$var$d("properties"))) {
            const t = this.properties, s = [
                ...$58e0238934c743c8$var$r(t),
                ...$58e0238934c743c8$var$o(t)
            ];
            for (const i of s)this.createProperty(i, t[i]);
        }
        const t = this[Symbol.metadata];
        if (null !== t) {
            const s = litPropertyMetadata.get(t);
            if (void 0 !== s) for (const [t, i] of s)this.elementProperties.set(t, i);
        }
        this._$Eh = new Map;
        for (const [t, s] of this.elementProperties){
            const i = this._$Eu(t, s);
            void 0 !== i && this._$Eh.set(i, t);
        }
        this.elementStyles = this.finalizeStyles(this.styles);
    }
    static finalizeStyles(s) {
        const i = [];
        if (Array.isArray(s)) {
            const e = new Set(s.flat(1 / 0).reverse());
            for (const s of e)i.unshift((0, $cc4e6a48b379d1fe$export$ee69dfd951e24778)(s));
        } else void 0 !== s && i.push((0, $cc4e6a48b379d1fe$export$ee69dfd951e24778)(s));
        return i;
    }
    static _$Eu(t, s) {
        const i = s.attribute;
        return !1 === i ? void 0 : "string" == typeof i ? i : "string" == typeof t ? t.toLowerCase() : void 0;
    }
    constructor(){
        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
    }
    _$Ev() {
        this._$ES = new Promise((t)=>this.enableUpdating = t), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t)=>t(this));
    }
    addController(t) {
        (this._$EO ??= new Set).add(t), void 0 !== this.renderRoot && this.isConnected && t.hostConnected?.();
    }
    removeController(t) {
        this._$EO?.delete(t);
    }
    _$E_() {
        const t = new Map, s = this.constructor.elementProperties;
        for (const i of s.keys())this.hasOwnProperty(i) && (t.set(i, this[i]), delete this[i]);
        t.size > 0 && (this._$Ep = t);
    }
    createRenderRoot() {
        const t = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
        return (0, $cc4e6a48b379d1fe$export$2ca4a66ec4cecb90)(t, this.constructor.elementStyles), t;
    }
    connectedCallback() {
        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((t)=>t.hostConnected?.());
    }
    enableUpdating(t) {}
    disconnectedCallback() {
        this._$EO?.forEach((t)=>t.hostDisconnected?.());
    }
    attributeChangedCallback(t, s, i) {
        this._$AK(t, i);
    }
    _$ET(t, s) {
        const i = this.constructor.elementProperties.get(t), e = this.constructor._$Eu(t, i);
        if (void 0 !== e && !0 === i.reflect) {
            const h = (void 0 !== i.converter?.toAttribute ? i.converter : $58e0238934c743c8$export$7312b35fbf521afb).toAttribute(s, i.type);
            this._$Em = t, null == h ? this.removeAttribute(e) : this.setAttribute(e, h), this._$Em = null;
        }
    }
    _$AK(t, s) {
        const i = this.constructor, e = i._$Eh.get(t);
        if (void 0 !== e && this._$Em !== e) {
            const t = i.getPropertyOptions(e), h = "function" == typeof t.converter ? {
                fromAttribute: t.converter
            } : void 0 !== t.converter?.fromAttribute ? t.converter : $58e0238934c743c8$export$7312b35fbf521afb;
            this._$Em = e;
            const r = h.fromAttribute(s, t.type);
            this[e] = r ?? this._$Ej?.get(e) ?? r, this._$Em = null;
        }
    }
    requestUpdate(t, s, i, e = !1, h) {
        if (void 0 !== t) {
            const r = this.constructor;
            if (!1 === e && (h = this[t]), i ??= r.getPropertyOptions(t), !((i.hasChanged ?? $58e0238934c743c8$export$53a6892c50694894)(h, s) || i.useDefault && i.reflect && h === this._$Ej?.get(t) && !this.hasAttribute(r._$Eu(t, i)))) return;
            this.C(t, s, i);
        }
        !1 === this.isUpdatePending && (this._$ES = this._$EP());
    }
    C(t, s, { useDefault: i, reflect: e, wrapped: h }, r) {
        i && !(this._$Ej ??= new Map).has(t) && (this._$Ej.set(t, r ?? s ?? this[t]), !0 !== h || void 0 !== r) || (this._$AL.has(t) || (this.hasUpdated || i || (s = void 0), this._$AL.set(t, s)), !0 === e && this._$Em !== t && (this._$Eq ??= new Set).add(t));
    }
    async _$EP() {
        this.isUpdatePending = !0;
        try {
            await this._$ES;
        } catch (t) {
            Promise.reject(t);
        }
        const t = this.scheduleUpdate();
        return null != t && await t, !this.isUpdatePending;
    }
    scheduleUpdate() {
        return this.performUpdate();
    }
    performUpdate() {
        if (!this.isUpdatePending) return;
        if (!this.hasUpdated) {
            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                for (const [t, s] of this._$Ep)this[t] = s;
                this._$Ep = void 0;
            }
            const t = this.constructor.elementProperties;
            if (t.size > 0) for (const [s, i] of t){
                const { wrapped: t } = i, e = this[s];
                !0 !== t || this._$AL.has(s) || void 0 === e || this.C(s, void 0, i, e);
            }
        }
        let t = !1;
        const s = this._$AL;
        try {
            t = this.shouldUpdate(s), t ? (this.willUpdate(s), this._$EO?.forEach((t)=>t.hostUpdate?.()), this.update(s)) : this._$EM();
        } catch (s) {
            throw t = !1, this._$EM(), s;
        }
        t && this._$AE(s);
    }
    willUpdate(t) {}
    _$AE(t) {
        this._$EO?.forEach((t)=>t.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(t)), this.updated(t);
    }
    _$EM() {
        this._$AL = new Map, this.isUpdatePending = !1;
    }
    get updateComplete() {
        return this.getUpdateComplete();
    }
    getUpdateComplete() {
        return this._$ES;
    }
    shouldUpdate(t) {
        return !0;
    }
    update(t) {
        this._$Eq &&= this._$Eq.forEach((t)=>this._$ET(t, this[t])), this._$EM();
    }
    updated(t) {}
    firstUpdated(t) {}
}
$58e0238934c743c8$export$c7c07a37856565d.elementStyles = [], $58e0238934c743c8$export$c7c07a37856565d.shadowRootOptions = {
    mode: "open"
}, $58e0238934c743c8$export$c7c07a37856565d[$58e0238934c743c8$var$d("elementProperties")] = new Map, $58e0238934c743c8$export$c7c07a37856565d[$58e0238934c743c8$var$d("finalized")] = new Map, $58e0238934c743c8$var$p?.({
    ReactiveElement: $58e0238934c743c8$export$c7c07a37856565d
}), ($58e0238934c743c8$var$a.reactiveElementVersions ??= []).push("2.1.2");


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e7d5e6add15542e8$var$t = globalThis, $e7d5e6add15542e8$var$i = (t)=>t, $e7d5e6add15542e8$var$s = $e7d5e6add15542e8$var$t.trustedTypes, $e7d5e6add15542e8$var$e = $e7d5e6add15542e8$var$s ? $e7d5e6add15542e8$var$s.createPolicy("lit-html", {
    createHTML: (t)=>t
}) : void 0, $e7d5e6add15542e8$var$h = "$lit$", $e7d5e6add15542e8$var$o = `lit$${Math.random().toFixed(9).slice(2)}$`, $e7d5e6add15542e8$var$n = "?" + $e7d5e6add15542e8$var$o, $e7d5e6add15542e8$var$r = `<${$e7d5e6add15542e8$var$n}>`, $e7d5e6add15542e8$var$l = document, $e7d5e6add15542e8$var$c = ()=>$e7d5e6add15542e8$var$l.createComment(""), $e7d5e6add15542e8$var$a = (t)=>null === t || "object" != typeof t && "function" != typeof t, $e7d5e6add15542e8$var$u = Array.isArray, $e7d5e6add15542e8$var$d = (t)=>$e7d5e6add15542e8$var$u(t) || "function" == typeof t?.[Symbol.iterator], $e7d5e6add15542e8$var$f = "[ \t\n\f\r]", $e7d5e6add15542e8$var$v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, $e7d5e6add15542e8$var$_ = /-->/g, $e7d5e6add15542e8$var$m = />/g, $e7d5e6add15542e8$var$p = RegExp(`>|${$e7d5e6add15542e8$var$f}(?:([^\\s"'>=/]+)(${$e7d5e6add15542e8$var$f}*=${$e7d5e6add15542e8$var$f}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), $e7d5e6add15542e8$var$g = /'/g, $e7d5e6add15542e8$var$$ = /"/g, $e7d5e6add15542e8$var$y = /^(?:script|style|textarea|title)$/i, $e7d5e6add15542e8$var$x = (t)=>(i, ...s)=>({
            _$litType$: t,
            strings: i,
            values: s
        }), $e7d5e6add15542e8$export$c0bb0b647f701bb5 = $e7d5e6add15542e8$var$x(1), $e7d5e6add15542e8$export$7ed1367e7fa1ad68 = $e7d5e6add15542e8$var$x(2), $e7d5e6add15542e8$export$47d5b44d225be5b4 = $e7d5e6add15542e8$var$x(3), $e7d5e6add15542e8$export$9c068ae9cc5db4e8 = Symbol.for("lit-noChange"), $e7d5e6add15542e8$export$45b790e32b2810ee = Symbol.for("lit-nothing"), $e7d5e6add15542e8$var$C = new WeakMap, $e7d5e6add15542e8$var$P = $e7d5e6add15542e8$var$l.createTreeWalker($e7d5e6add15542e8$var$l, 129);
function $e7d5e6add15542e8$var$V(t, i) {
    if (!$e7d5e6add15542e8$var$u(t) || !t.hasOwnProperty("raw")) throw Error("invalid template strings array");
    return void 0 !== $e7d5e6add15542e8$var$e ? $e7d5e6add15542e8$var$e.createHTML(i) : i;
}
const $e7d5e6add15542e8$var$N = (t, i)=>{
    const s = t.length - 1, e = [];
    let n, l = 2 === i ? "<svg>" : 3 === i ? "<math>" : "", c = $e7d5e6add15542e8$var$v;
    for(let i = 0; i < s; i++){
        const s = t[i];
        let a, u, d = -1, f = 0;
        for(; f < s.length && (c.lastIndex = f, u = c.exec(s), null !== u);)f = c.lastIndex, c === $e7d5e6add15542e8$var$v ? "!--" === u[1] ? c = $e7d5e6add15542e8$var$_ : void 0 !== u[1] ? c = $e7d5e6add15542e8$var$m : void 0 !== u[2] ? ($e7d5e6add15542e8$var$y.test(u[2]) && (n = RegExp("</" + u[2], "g")), c = $e7d5e6add15542e8$var$p) : void 0 !== u[3] && (c = $e7d5e6add15542e8$var$p) : c === $e7d5e6add15542e8$var$p ? ">" === u[0] ? (c = n ?? $e7d5e6add15542e8$var$v, d = -1) : void 0 === u[1] ? d = -2 : (d = c.lastIndex - u[2].length, a = u[1], c = void 0 === u[3] ? $e7d5e6add15542e8$var$p : '"' === u[3] ? $e7d5e6add15542e8$var$$ : $e7d5e6add15542e8$var$g) : c === $e7d5e6add15542e8$var$$ || c === $e7d5e6add15542e8$var$g ? c = $e7d5e6add15542e8$var$p : c === $e7d5e6add15542e8$var$_ || c === $e7d5e6add15542e8$var$m ? c = $e7d5e6add15542e8$var$v : (c = $e7d5e6add15542e8$var$p, n = void 0);
        const x = c === $e7d5e6add15542e8$var$p && t[i + 1].startsWith("/>") ? " " : "";
        l += c === $e7d5e6add15542e8$var$v ? s + $e7d5e6add15542e8$var$r : d >= 0 ? (e.push(a), s.slice(0, d) + $e7d5e6add15542e8$var$h + s.slice(d) + $e7d5e6add15542e8$var$o + x) : s + $e7d5e6add15542e8$var$o + (-2 === d ? i : x);
    }
    return [
        $e7d5e6add15542e8$var$V(t, l + (t[s] || "<?>") + (2 === i ? "</svg>" : 3 === i ? "</math>" : "")),
        e
    ];
};
class $e7d5e6add15542e8$var$S {
    constructor({ strings: t, _$litType$: i }, e){
        let r;
        this.parts = [];
        let l = 0, a = 0;
        const u = t.length - 1, d = this.parts, [f, v] = $e7d5e6add15542e8$var$N(t, i);
        if (this.el = $e7d5e6add15542e8$var$S.createElement(f, e), $e7d5e6add15542e8$var$P.currentNode = this.el.content, 2 === i || 3 === i) {
            const t = this.el.content.firstChild;
            t.replaceWith(...t.childNodes);
        }
        for(; null !== (r = $e7d5e6add15542e8$var$P.nextNode()) && d.length < u;){
            if (1 === r.nodeType) {
                if (r.hasAttributes()) for (const t of r.getAttributeNames())if (t.endsWith($e7d5e6add15542e8$var$h)) {
                    const i = v[a++], s = r.getAttribute(t).split($e7d5e6add15542e8$var$o), e = /([.?@])?(.*)/.exec(i);
                    d.push({
                        type: 1,
                        index: l,
                        name: e[2],
                        strings: s,
                        ctor: "." === e[1] ? $e7d5e6add15542e8$var$I : "?" === e[1] ? $e7d5e6add15542e8$var$L : "@" === e[1] ? $e7d5e6add15542e8$var$z : $e7d5e6add15542e8$var$H
                    }), r.removeAttribute(t);
                } else t.startsWith($e7d5e6add15542e8$var$o) && (d.push({
                    type: 6,
                    index: l
                }), r.removeAttribute(t));
                if ($e7d5e6add15542e8$var$y.test(r.tagName)) {
                    const t = r.textContent.split($e7d5e6add15542e8$var$o), i = t.length - 1;
                    if (i > 0) {
                        r.textContent = $e7d5e6add15542e8$var$s ? $e7d5e6add15542e8$var$s.emptyScript : "";
                        for(let s = 0; s < i; s++)r.append(t[s], $e7d5e6add15542e8$var$c()), $e7d5e6add15542e8$var$P.nextNode(), d.push({
                            type: 2,
                            index: ++l
                        });
                        r.append(t[i], $e7d5e6add15542e8$var$c());
                    }
                }
            } else if (8 === r.nodeType) {
                if (r.data === $e7d5e6add15542e8$var$n) d.push({
                    type: 2,
                    index: l
                });
                else {
                    let t = -1;
                    for(; -1 !== (t = r.data.indexOf($e7d5e6add15542e8$var$o, t + 1));)d.push({
                        type: 7,
                        index: l
                    }), t += $e7d5e6add15542e8$var$o.length - 1;
                }
            }
            l++;
        }
    }
    static createElement(t, i) {
        const s = $e7d5e6add15542e8$var$l.createElement("template");
        return s.innerHTML = t, s;
    }
}
function $e7d5e6add15542e8$var$M(t, i, s = t, e) {
    if (i === $e7d5e6add15542e8$export$9c068ae9cc5db4e8) return i;
    let h = void 0 !== e ? s._$Co?.[e] : s._$Cl;
    const o = $e7d5e6add15542e8$var$a(i) ? void 0 : i._$litDirective$;
    return h?.constructor !== o && (h?._$AO?.(!1), void 0 === o ? h = void 0 : (h = new o(t), h._$AT(t, s, e)), void 0 !== e ? (s._$Co ??= [])[e] = h : s._$Cl = h), void 0 !== h && (i = $e7d5e6add15542e8$var$M(t, h._$AS(t, i.values), h, e)), i;
}
class $e7d5e6add15542e8$var$R {
    constructor(t, i){
        this._$AV = [], this._$AN = void 0, this._$AD = t, this._$AM = i;
    }
    get parentNode() {
        return this._$AM.parentNode;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    u(t) {
        const { el: { content: i }, parts: s } = this._$AD, e = (t?.creationScope ?? $e7d5e6add15542e8$var$l).importNode(i, !0);
        $e7d5e6add15542e8$var$P.currentNode = e;
        let h = $e7d5e6add15542e8$var$P.nextNode(), o = 0, n = 0, r = s[0];
        for(; void 0 !== r;){
            if (o === r.index) {
                let i;
                2 === r.type ? i = new $e7d5e6add15542e8$var$k(h, h.nextSibling, this, t) : 1 === r.type ? i = new r.ctor(h, r.name, r.strings, this, t) : 6 === r.type && (i = new $e7d5e6add15542e8$var$Z(h, this, t)), this._$AV.push(i), r = s[++n];
            }
            o !== r?.index && (h = $e7d5e6add15542e8$var$P.nextNode(), o++);
        }
        return $e7d5e6add15542e8$var$P.currentNode = $e7d5e6add15542e8$var$l, e;
    }
    p(t) {
        let i = 0;
        for (const s of this._$AV)void 0 !== s && (void 0 !== s.strings ? (s._$AI(t, s, i), i += s.strings.length - 2) : s._$AI(t[i])), i++;
    }
}
class $e7d5e6add15542e8$var$k {
    get _$AU() {
        return this._$AM?._$AU ?? this._$Cv;
    }
    constructor(t, i, s, e){
        this.type = 2, this._$AH = $e7d5e6add15542e8$export$45b790e32b2810ee, this._$AN = void 0, this._$AA = t, this._$AB = i, this._$AM = s, this.options = e, this._$Cv = e?.isConnected ?? !0;
    }
    get parentNode() {
        let t = this._$AA.parentNode;
        const i = this._$AM;
        return void 0 !== i && 11 === t?.nodeType && (t = i.parentNode), t;
    }
    get startNode() {
        return this._$AA;
    }
    get endNode() {
        return this._$AB;
    }
    _$AI(t, i = this) {
        t = $e7d5e6add15542e8$var$M(this, t, i), $e7d5e6add15542e8$var$a(t) ? t === $e7d5e6add15542e8$export$45b790e32b2810ee || null == t || "" === t ? (this._$AH !== $e7d5e6add15542e8$export$45b790e32b2810ee && this._$AR(), this._$AH = $e7d5e6add15542e8$export$45b790e32b2810ee) : t !== this._$AH && t !== $e7d5e6add15542e8$export$9c068ae9cc5db4e8 && this._(t) : void 0 !== t._$litType$ ? this.$(t) : void 0 !== t.nodeType ? this.T(t) : $e7d5e6add15542e8$var$d(t) ? this.k(t) : this._(t);
    }
    O(t) {
        return this._$AA.parentNode.insertBefore(t, this._$AB);
    }
    T(t) {
        this._$AH !== t && (this._$AR(), this._$AH = this.O(t));
    }
    _(t) {
        this._$AH !== $e7d5e6add15542e8$export$45b790e32b2810ee && $e7d5e6add15542e8$var$a(this._$AH) ? this._$AA.nextSibling.data = t : this.T($e7d5e6add15542e8$var$l.createTextNode(t)), this._$AH = t;
    }
    $(t) {
        const { values: i, _$litType$: s } = t, e = "number" == typeof s ? this._$AC(t) : (void 0 === s.el && (s.el = $e7d5e6add15542e8$var$S.createElement($e7d5e6add15542e8$var$V(s.h, s.h[0]), this.options)), s);
        if (this._$AH?._$AD === e) this._$AH.p(i);
        else {
            const t = new $e7d5e6add15542e8$var$R(e, this), s = t.u(this.options);
            t.p(i), this.T(s), this._$AH = t;
        }
    }
    _$AC(t) {
        let i = $e7d5e6add15542e8$var$C.get(t.strings);
        return void 0 === i && $e7d5e6add15542e8$var$C.set(t.strings, i = new $e7d5e6add15542e8$var$S(t)), i;
    }
    k(t) {
        $e7d5e6add15542e8$var$u(this._$AH) || (this._$AH = [], this._$AR());
        const i = this._$AH;
        let s, e = 0;
        for (const h of t)e === i.length ? i.push(s = new $e7d5e6add15542e8$var$k(this.O($e7d5e6add15542e8$var$c()), this.O($e7d5e6add15542e8$var$c()), this, this.options)) : s = i[e], s._$AI(h), e++;
        e < i.length && (this._$AR(s && s._$AB.nextSibling, e), i.length = e);
    }
    _$AR(t = this._$AA.nextSibling, s) {
        for(this._$AP?.(!1, !0, s); t !== this._$AB;){
            const s = $e7d5e6add15542e8$var$i(t).nextSibling;
            $e7d5e6add15542e8$var$i(t).remove(), t = s;
        }
    }
    setConnected(t) {
        void 0 === this._$AM && (this._$Cv = t, this._$AP?.(t));
    }
}
class $e7d5e6add15542e8$var$H {
    get tagName() {
        return this.element.tagName;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    constructor(t, i, s, e, h){
        this.type = 1, this._$AH = $e7d5e6add15542e8$export$45b790e32b2810ee, this._$AN = void 0, this.element = t, this.name = i, this._$AM = e, this.options = h, s.length > 2 || "" !== s[0] || "" !== s[1] ? (this._$AH = Array(s.length - 1).fill(new String), this.strings = s) : this._$AH = $e7d5e6add15542e8$export$45b790e32b2810ee;
    }
    _$AI(t, i = this, s, e) {
        const h = this.strings;
        let o = !1;
        if (void 0 === h) t = $e7d5e6add15542e8$var$M(this, t, i, 0), o = !$e7d5e6add15542e8$var$a(t) || t !== this._$AH && t !== $e7d5e6add15542e8$export$9c068ae9cc5db4e8, o && (this._$AH = t);
        else {
            const e = t;
            let n, r;
            for(t = h[0], n = 0; n < h.length - 1; n++)r = $e7d5e6add15542e8$var$M(this, e[s + n], i, n), r === $e7d5e6add15542e8$export$9c068ae9cc5db4e8 && (r = this._$AH[n]), o ||= !$e7d5e6add15542e8$var$a(r) || r !== this._$AH[n], r === $e7d5e6add15542e8$export$45b790e32b2810ee ? t = $e7d5e6add15542e8$export$45b790e32b2810ee : t !== $e7d5e6add15542e8$export$45b790e32b2810ee && (t += (r ?? "") + h[n + 1]), this._$AH[n] = r;
        }
        o && !e && this.j(t);
    }
    j(t) {
        t === $e7d5e6add15542e8$export$45b790e32b2810ee ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t ?? "");
    }
}
class $e7d5e6add15542e8$var$I extends $e7d5e6add15542e8$var$H {
    constructor(){
        super(...arguments), this.type = 3;
    }
    j(t) {
        this.element[this.name] = t === $e7d5e6add15542e8$export$45b790e32b2810ee ? void 0 : t;
    }
}
class $e7d5e6add15542e8$var$L extends $e7d5e6add15542e8$var$H {
    constructor(){
        super(...arguments), this.type = 4;
    }
    j(t) {
        this.element.toggleAttribute(this.name, !!t && t !== $e7d5e6add15542e8$export$45b790e32b2810ee);
    }
}
class $e7d5e6add15542e8$var$z extends $e7d5e6add15542e8$var$H {
    constructor(t, i, s, e, h){
        super(t, i, s, e, h), this.type = 5;
    }
    _$AI(t, i = this) {
        if ((t = $e7d5e6add15542e8$var$M(this, t, i, 0) ?? $e7d5e6add15542e8$export$45b790e32b2810ee) === $e7d5e6add15542e8$export$9c068ae9cc5db4e8) return;
        const s = this._$AH, e = t === $e7d5e6add15542e8$export$45b790e32b2810ee && s !== $e7d5e6add15542e8$export$45b790e32b2810ee || t.capture !== s.capture || t.once !== s.once || t.passive !== s.passive, h = t !== $e7d5e6add15542e8$export$45b790e32b2810ee && (s === $e7d5e6add15542e8$export$45b790e32b2810ee || e);
        e && this.element.removeEventListener(this.name, this, s), h && this.element.addEventListener(this.name, this, t), this._$AH = t;
    }
    handleEvent(t) {
        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t) : this._$AH.handleEvent(t);
    }
}
class $e7d5e6add15542e8$var$Z {
    constructor(t, i, s){
        this.element = t, this.type = 6, this._$AN = void 0, this._$AM = i, this.options = s;
    }
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AI(t) {
        $e7d5e6add15542e8$var$M(this, t);
    }
}
const $e7d5e6add15542e8$export$8613d1ca9052b22e = {
    M: $e7d5e6add15542e8$var$h,
    P: $e7d5e6add15542e8$var$o,
    A: $e7d5e6add15542e8$var$n,
    C: 1,
    L: $e7d5e6add15542e8$var$N,
    R: $e7d5e6add15542e8$var$R,
    D: $e7d5e6add15542e8$var$d,
    V: $e7d5e6add15542e8$var$M,
    I: $e7d5e6add15542e8$var$k,
    H: $e7d5e6add15542e8$var$H,
    N: $e7d5e6add15542e8$var$L,
    U: $e7d5e6add15542e8$var$z,
    B: $e7d5e6add15542e8$var$I,
    F: $e7d5e6add15542e8$var$Z
}, $e7d5e6add15542e8$var$B = $e7d5e6add15542e8$var$t.litHtmlPolyfillSupport;
$e7d5e6add15542e8$var$B?.($e7d5e6add15542e8$var$S, $e7d5e6add15542e8$var$k), ($e7d5e6add15542e8$var$t.litHtmlVersions ??= []).push("3.3.3");
const $e7d5e6add15542e8$export$b3890eb0ae9dca99 = (t, i, s)=>{
    const e = s?.renderBefore ?? i;
    let h = e._$litPart$;
    if (void 0 === h) {
        const t = s?.renderBefore ?? null;
        e._$litPart$ = h = new $e7d5e6add15542e8$var$k(i.insertBefore($e7d5e6add15542e8$var$c(), t), t, void 0, s ?? {});
    }
    return h._$AI(t), h;
};




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $f1ffc5e56da42974$var$s = globalThis;
class $f1ffc5e56da42974$export$3f2f9f5909897157 extends (0, $58e0238934c743c8$export$c7c07a37856565d) {
    constructor(){
        super(...arguments), this.renderOptions = {
            host: this
        }, this._$Do = void 0;
    }
    createRenderRoot() {
        const t = super.createRenderRoot();
        return this.renderOptions.renderBefore ??= t.firstChild, t;
    }
    update(t) {
        const r = this.render();
        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t), this._$Do = (0, $e7d5e6add15542e8$export$b3890eb0ae9dca99)(r, this.renderRoot, this.renderOptions);
    }
    connectedCallback() {
        super.connectedCallback(), this._$Do?.setConnected(!0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._$Do?.setConnected(!1);
    }
    render() {
        return 0, $e7d5e6add15542e8$export$9c068ae9cc5db4e8;
    }
}
$f1ffc5e56da42974$export$3f2f9f5909897157._$litElement$ = !0, $f1ffc5e56da42974$export$3f2f9f5909897157["finalized"] = !0, $f1ffc5e56da42974$var$s.litElementHydrateSupport?.({
    LitElement: $f1ffc5e56da42974$export$3f2f9f5909897157
});
const $f1ffc5e56da42974$var$o = $f1ffc5e56da42974$var$s.litElementPolyfillSupport;
$f1ffc5e56da42974$var$o?.({
    LitElement: $f1ffc5e56da42974$export$3f2f9f5909897157
});
const $f1ffc5e56da42974$export$f5c524615a7708d6 = {
    _$AK: (t, e, r)=>{
        t._$AK(e, r);
    },
    _$AL: (t)=>t._$AL
};
($f1ffc5e56da42974$var$s.litElementVersions ??= []).push("4.2.2");


/**
 * @license
 * Copyright 2022 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $e716b92e678e56f2$export$6acf61af03e62db = !1;




var $b050f32796b07fe6$export$e0460a263d3b7bef = (0, $cc4e6a48b379d1fe$export$dbf350e5966cf602)`
  :host {
    display: block;
  }

  .details {
    border: solid 1px var(--sl-color-neutral-200);
    border-radius: var(--sl-border-radius-medium);
    background-color: var(--sl-color-neutral-0);
    overflow-anchor: none;
  }

  .details--disabled {
    opacity: 0.5;
  }

  .details__header {
    display: flex;
    align-items: center;
    border-radius: inherit;
    padding: var(--sl-spacing-medium);
    user-select: none;
    -webkit-user-select: none;
    cursor: pointer;
  }

  .details__header::-webkit-details-marker {
    display: none;
  }

  .details__header:focus {
    outline: none;
  }

  .details__header:focus-visible {
    outline: var(--sl-focus-ring);
    outline-offset: calc(1px + var(--sl-focus-ring-offset));
  }

  .details--disabled .details__header {
    cursor: not-allowed;
  }

  .details--disabled .details__header:focus-visible {
    outline: none;
    box-shadow: none;
  }

  .details__summary {
    flex: 1 1 auto;
    display: flex;
    align-items: center;
  }

  .details__summary-icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    transition: var(--sl-transition-medium) rotate ease;
  }

  .details--open .details__summary-icon {
    rotate: 90deg;
  }

  .details--open.details--rtl .details__summary-icon {
    rotate: -90deg;
  }

  .details--open slot[name='expand-icon'],
  .details:not(.details--open) slot[name='collapse-icon'] {
    display: none;
  }

  .details__body {
    overflow: hidden;
  }

  .details__content {
    display: block;
    padding: var(--sl-spacing-medium);
  }
`;


var $740df691e57c097e$var$__defProp = Object.defineProperty;
var $740df691e57c097e$var$__defProps = Object.defineProperties;
var $740df691e57c097e$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $740df691e57c097e$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $740df691e57c097e$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $740df691e57c097e$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $740df691e57c097e$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $740df691e57c097e$var$__knownSymbol = (name, symbol)=>(symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
var $740df691e57c097e$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $740df691e57c097e$var$__defNormalProp = (obj, key, value)=>key in obj ? $740df691e57c097e$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $740df691e57c097e$export$7de063a7aa429f6c = (a, b)=>{
    for(var prop in b || (b = {}))if ($740df691e57c097e$var$__hasOwnProp.call(b, prop)) $740df691e57c097e$var$__defNormalProp(a, prop, b[prop]);
    if ($740df691e57c097e$var$__getOwnPropSymbols) {
        for (var prop of $740df691e57c097e$var$__getOwnPropSymbols(b))if ($740df691e57c097e$var$__propIsEnum.call(b, prop)) $740df691e57c097e$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $740df691e57c097e$export$f4da8f157c1253f7 = (a, b)=>$740df691e57c097e$var$__defProps(a, $740df691e57c097e$var$__getOwnPropDescs(b));
var $740df691e57c097e$export$85c93885f16e8446 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $740df691e57c097e$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $740df691e57c097e$var$__defProp(target, key, result);
    return result;
};
var $740df691e57c097e$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $740df691e57c097e$var$__typeError("Cannot " + msg);
var $740df691e57c097e$export$18a094aefa070634 = (obj, member, getter)=>($740df691e57c097e$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $740df691e57c097e$export$addf369becd23283 = (obj, member, value)=>member.has(obj) ? $740df691e57c097e$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var $740df691e57c097e$export$42432efe6614d3b4 = (obj, member, value, setter)=>($740df691e57c097e$var$__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var $740df691e57c097e$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $740df691e57c097e$export$5590fd18e5672c2 = (value)=>{
    var obj = value[$740df691e57c097e$var$__knownSymbol("asyncIterator")], isAwait = false, method, it = {};
    if (obj == null) {
        obj = value[$740df691e57c097e$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $740df691e57c097e$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) $740df691e57c097e$var$__typeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$740df691e57c097e$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};


// src/utilities/animation-registry.ts
var $be66bbac00f5dd56$var$defaultAnimationRegistry = /* @__PURE__ */ new Map();
var $be66bbac00f5dd56$var$customAnimationRegistry = /* @__PURE__ */ new WeakMap();
function $be66bbac00f5dd56$var$ensureAnimation(animation) {
    return animation != null ? animation : {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}
function $be66bbac00f5dd56$var$getLogicalAnimation(animation, dir) {
    if (dir.toLowerCase() === "rtl") return {
        keyframes: animation.rtlKeyframes || animation.keyframes,
        options: animation.options
    };
    return animation;
}
function $be66bbac00f5dd56$export$6e92ecdbe15fda0b(animationName, animation) {
    $be66bbac00f5dd56$var$defaultAnimationRegistry.set(animationName, $be66bbac00f5dd56$var$ensureAnimation(animation));
}
function $be66bbac00f5dd56$export$ea45326d94a48a31(el, animationName, animation) {
    $be66bbac00f5dd56$var$customAnimationRegistry.set(el, (0, $740df691e57c097e$export$f4da8f157c1253f7)((0, $740df691e57c097e$export$7de063a7aa429f6c)({}, $be66bbac00f5dd56$var$customAnimationRegistry.get(el)), {
        [animationName]: $be66bbac00f5dd56$var$ensureAnimation(animation)
    }));
}
function $be66bbac00f5dd56$export$b1aed5dec0c2d368(el, animationName, options) {
    const customAnimation = $be66bbac00f5dd56$var$customAnimationRegistry.get(el);
    if (customAnimation == null ? void 0 : customAnimation[animationName]) return $be66bbac00f5dd56$var$getLogicalAnimation(customAnimation[animationName], options.dir);
    const defaultAnimation = $be66bbac00f5dd56$var$defaultAnimationRegistry.get(animationName);
    if (defaultAnimation) return $be66bbac00f5dd56$var$getLogicalAnimation(defaultAnimation, options.dir);
    return {
        keyframes: [],
        options: {
            duration: 0
        }
    };
}


// src/internal/event.ts
function $7eaf42424ddc4bed$export$6608ab6fe9313967(el, eventName) {
    return new Promise((resolve)=>{
        function done(event) {
            if (event.target === el) {
                el.removeEventListener(eventName, done);
                resolve();
            }
        }
        el.addEventListener(eventName, done);
    });
}



// src/internal/animate.ts
function $eb4d5de33b0d3712$export$3b755839a54e1bb0(el, keyframes, options) {
    return new Promise((resolve)=>{
        if ((options == null ? void 0 : options.duration) === Infinity) throw new Error("Promise-based animations must be finite.");
        const animation = el.animate(keyframes, (0, $740df691e57c097e$export$f4da8f157c1253f7)((0, $740df691e57c097e$export$7de063a7aa429f6c)({}, options), {
            duration: $eb4d5de33b0d3712$export$ff7706047246b98b() ? 0 : options.duration
        }));
        animation.addEventListener("cancel", resolve, {
            once: true
        });
        animation.addEventListener("finish", resolve, {
            once: true
        });
    });
}
function $eb4d5de33b0d3712$export$ecae829bb3747ea6(delay) {
    delay = delay.toString().toLowerCase();
    if (delay.indexOf("ms") > -1) return parseFloat(delay);
    if (delay.indexOf("s") > -1) return parseFloat(delay) * 1e3;
    return parseFloat(delay);
}
function $eb4d5de33b0d3712$export$ff7706047246b98b() {
    const query = window.matchMedia("(prefers-reduced-motion: reduce)");
    return query.matches;
}
function $eb4d5de33b0d3712$export$ad12f740028ccbea(el) {
    return Promise.all(el.getAnimations().map((animation)=>{
        return new Promise((resolve)=>{
            animation.cancel();
            requestAnimationFrame(resolve);
        });
    }));
}
function $eb4d5de33b0d3712$export$783a9b5bf095072a(keyframes, calculatedHeight) {
    return keyframes.map((keyframe)=>(0, $740df691e57c097e$export$f4da8f157c1253f7)((0, $740df691e57c097e$export$7de063a7aa429f6c)({}, keyframe), {
            height: keyframe.height === "auto" ? `${calculatedHeight}px` : keyframe.height
        }));
}


// src/translations/en.ts
const $0202b2fb02e639f1$var$connectedElements = new Set();
const $0202b2fb02e639f1$var$translations = new Map();
let $0202b2fb02e639f1$var$fallback;
let $0202b2fb02e639f1$var$documentDirection = 'ltr';
let $0202b2fb02e639f1$var$documentLanguage = 'en';
const $0202b2fb02e639f1$var$isClient = typeof MutationObserver !== 'undefined' && typeof document !== 'undefined' && typeof document.documentElement !== 'undefined';
if ($0202b2fb02e639f1$var$isClient) {
    const documentElementObserver = new MutationObserver($0202b2fb02e639f1$export$722fbec263ad908a);
    $0202b2fb02e639f1$var$documentDirection = document.documentElement.dir || 'ltr';
    $0202b2fb02e639f1$var$documentLanguage = document.documentElement.lang || navigator.language;
    documentElementObserver.observe(document.documentElement, {
        attributes: true,
        attributeFilter: [
            'dir',
            'lang'
        ]
    });
}
function $0202b2fb02e639f1$export$2332cb3ce32cc839(...translation) {
    translation.map((t)=>{
        const code = t.$code.toLowerCase();
        if ($0202b2fb02e639f1$var$translations.has(code)) $0202b2fb02e639f1$var$translations.set(code, Object.assign(Object.assign({}, $0202b2fb02e639f1$var$translations.get(code)), t));
        else $0202b2fb02e639f1$var$translations.set(code, t);
        if (!$0202b2fb02e639f1$var$fallback) $0202b2fb02e639f1$var$fallback = t;
    });
    $0202b2fb02e639f1$export$722fbec263ad908a();
}
function $0202b2fb02e639f1$export$722fbec263ad908a() {
    if ($0202b2fb02e639f1$var$isClient) {
        $0202b2fb02e639f1$var$documentDirection = document.documentElement.dir || 'ltr';
        $0202b2fb02e639f1$var$documentLanguage = document.documentElement.lang || navigator.language;
    }
    [
        ...$0202b2fb02e639f1$var$connectedElements.keys()
    ].map((el)=>{
        if (typeof el.requestUpdate === 'function') el.requestUpdate();
    });
}
class $0202b2fb02e639f1$export$b1a2fed5bb41b893 {
    constructor(host){
        this.host = host;
        this.host.addController(this);
    }
    hostConnected() {
        $0202b2fb02e639f1$var$connectedElements.add(this.host);
    }
    hostDisconnected() {
        $0202b2fb02e639f1$var$connectedElements.delete(this.host);
    }
    dir() {
        return `${this.host.dir || $0202b2fb02e639f1$var$documentDirection}`.toLowerCase();
    }
    lang() {
        return `${this.host.lang || $0202b2fb02e639f1$var$documentLanguage}`.toLowerCase();
    }
    getTranslationData(lang) {
        var _a, _b;
        let locale;
        try {
            locale = new Intl.Locale(lang.replace(/_/g, '-'));
        } catch (_c) {
            return {
                locale: undefined,
                language: '',
                region: '',
                primary: undefined,
                secondary: undefined
            };
        }
        const language = locale.language.toLowerCase();
        const region = (_b = (_a = locale.region) === null || _a === void 0 ? void 0 : _a.toLowerCase()) !== null && _b !== void 0 ? _b : '';
        const primary = $0202b2fb02e639f1$var$translations.get(`${language}-${region}`);
        const secondary = $0202b2fb02e639f1$var$translations.get(language);
        return {
            locale: locale,
            language: language,
            region: region,
            primary: primary,
            secondary: secondary
        };
    }
    exists(key, options) {
        var _a;
        const { primary: primary, secondary: secondary } = this.getTranslationData((_a = options.lang) !== null && _a !== void 0 ? _a : this.lang());
        options = Object.assign({
            includeFallback: false
        }, options);
        if (primary && primary[key] || secondary && secondary[key] || options.includeFallback && $0202b2fb02e639f1$var$fallback && $0202b2fb02e639f1$var$fallback[key]) return true;
        return false;
    }
    term(key, ...args) {
        const { primary: primary, secondary: secondary } = this.getTranslationData(this.lang());
        let term;
        if (primary && primary[key]) term = primary[key];
        else if (secondary && secondary[key]) term = secondary[key];
        else if ($0202b2fb02e639f1$var$fallback && $0202b2fb02e639f1$var$fallback[key]) term = $0202b2fb02e639f1$var$fallback[key];
        else {
            console.error(`No translation found for: ${String(key)}`);
            return String(key);
        }
        if (typeof term === 'function') return term(...args);
        return term;
    }
    date(dateToFormat, options) {
        dateToFormat = new Date(dateToFormat);
        return new Intl.DateTimeFormat(this.lang(), options).format(dateToFormat);
    }
    number(numberToFormat, options) {
        numberToFormat = Number(numberToFormat);
        return isNaN(numberToFormat) ? '' : new Intl.NumberFormat(this.lang(), options).format(numberToFormat);
    }
    relativeTime(value, unit, options) {
        return new Intl.RelativeTimeFormat(this.lang(), options).format(value, unit);
    }
}


var $5706347945ebaa4f$var$translation = {
    $code: "en",
    $name: "English",
    $dir: "ltr",
    carousel: "Carousel",
    clearEntry: "Clear entry",
    close: "Close",
    copied: "Copied",
    copy: "Copy",
    currentValue: "Current value",
    error: "Error",
    goToSlide: (slide, count)=>`Go to slide ${slide} of ${count}`,
    hidePassword: "Hide password",
    loading: "Loading",
    nextSlide: "Next slide",
    numOptionsSelected: (num)=>{
        if (num === 0) return "No options selected";
        if (num === 1) return "1 option selected";
        return `${num} options selected`;
    },
    previousSlide: "Previous slide",
    progress: "Progress",
    remove: "Remove",
    resize: "Resize",
    scrollToEnd: "Scroll to end",
    scrollToStart: "Scroll to start",
    selectAColorFromTheScreen: "Select a color from the screen",
    showPassword: "Show password",
    slideNum: (slide)=>`Slide ${slide}`,
    toggleColorFormat: "Toggle color format"
};
(0, $0202b2fb02e639f1$export$2332cb3ce32cc839)($5706347945ebaa4f$var$translation);
var $5706347945ebaa4f$export$802b895dc4aecf21 = $5706347945ebaa4f$var$translation;



var $b8c5b97ae6a60640$export$b1a2fed5bb41b893 = class extends (0, $0202b2fb02e639f1$export$b1a2fed5bb41b893) {
};
(0, $0202b2fb02e639f1$export$2332cb3ce32cc839)((0, $5706347945ebaa4f$export$802b895dc4aecf21));


// src/utilities/base-path.ts
var $18ce20b459d623e7$var$basePath = "";
function $18ce20b459d623e7$export$784ad41d332938c6(path) {
    $18ce20b459d623e7$var$basePath = path;
}
function $18ce20b459d623e7$export$9099264ed9b1c55a(subpath = "") {
    if (!$18ce20b459d623e7$var$basePath) {
        const scripts = [
            ...document.getElementsByTagName("script")
        ];
        const configScript = scripts.find((script)=>script.hasAttribute("data-shoelace"));
        if (configScript) $18ce20b459d623e7$export$784ad41d332938c6(configScript.getAttribute("data-shoelace"));
        else {
            const fallbackScript = scripts.find((s)=>{
                return /shoelace(\.min)?\.js($|\?)/.test(s.src) || /shoelace-autoloader(\.min)?\.js($|\?)/.test(s.src);
            });
            let path = "";
            if (fallbackScript) path = fallbackScript.getAttribute("src");
            $18ce20b459d623e7$export$784ad41d332938c6(path.split("/").slice(0, -1).join("/"));
        }
    }
    return $18ce20b459d623e7$var$basePath.replace(/\/$/, "") + (subpath ? `/${subpath.replace(/^\//, "")}` : ``);
}


// src/components/icon/library.default.ts
var $3a472a6f5dfd296e$var$library = {
    name: "default",
    resolver: (name)=>(0, $18ce20b459d623e7$export$9099264ed9b1c55a)(`assets/icons/${name}.svg`)
};
var $3a472a6f5dfd296e$export$761783e099ce3526 = $3a472a6f5dfd296e$var$library;


// src/components/icon/library.system.ts
var $c292ca9e30d60186$var$icons = {
    caret: `
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <polyline points="6 9 12 15 18 9"></polyline>
    </svg>
  `,
    check: `
    <svg part="checked-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor">
          <g transform="translate(3.428571, 3.428571)">
            <path d="M0,5.71428571 L3.42857143,9.14285714"></path>
            <path d="M9.14285714,0 L3.42857143,9.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "chevron-down": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    "chevron-left": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-left" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
    </svg>
  `,
    "chevron-right": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
    </svg>
  `,
    copy: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-copy" viewBox="0 0 16 16">
      <path fill-rule="evenodd" d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V2Zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H6ZM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1H2Z"/>
    </svg>
  `,
    eye: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye" viewBox="0 0 16 16">
      <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z"/>
      <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z"/>
    </svg>
  `,
    "eye-slash": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eye-slash" viewBox="0 0 16 16">
      <path d="M13.359 11.238C15.06 9.72 16 8 16 8s-3-5.5-8-5.5a7.028 7.028 0 0 0-2.79.588l.77.771A5.944 5.944 0 0 1 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.134 13.134 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755-.165.165-.337.328-.517.486l.708.709z"/>
      <path d="M11.297 9.176a3.5 3.5 0 0 0-4.474-4.474l.823.823a2.5 2.5 0 0 1 2.829 2.829l.822.822zm-2.943 1.299.822.822a3.5 3.5 0 0 1-4.474-4.474l.823.823a2.5 2.5 0 0 0 2.829 2.829z"/>
      <path d="M3.35 5.47c-.18.16-.353.322-.518.487A13.134 13.134 0 0 0 1.172 8l.195.288c.335.48.83 1.12 1.465 1.755C4.121 11.332 5.881 12.5 8 12.5c.716 0 1.39-.133 2.02-.36l.77.772A7.029 7.029 0 0 1 8 13.5C3 13.5 0 8 0 8s.939-1.721 2.641-3.238l.708.709zm10.296 8.884-12-12 .708-.708 12 12-.708.708z"/>
    </svg>
  `,
    eyedropper: `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-eyedropper" viewBox="0 0 16 16">
      <path d="M13.354.646a1.207 1.207 0 0 0-1.708 0L8.5 3.793l-.646-.647a.5.5 0 1 0-.708.708L8.293 5l-7.147 7.146A.5.5 0 0 0 1 12.5v1.793l-.854.853a.5.5 0 1 0 .708.707L1.707 15H3.5a.5.5 0 0 0 .354-.146L11 7.707l1.146 1.147a.5.5 0 0 0 .708-.708l-.647-.646 3.147-3.146a1.207 1.207 0 0 0 0-1.708l-2-2zM2 12.707l7-7L10.293 7l-7 7H2v-1.293z"></path>
    </svg>
  `,
    "grip-vertical": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-grip-vertical" viewBox="0 0 16 16">
      <path d="M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zM7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"></path>
    </svg>
  `,
    indeterminate: `
    <svg part="indeterminate-icon" class="checkbox__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round">
        <g stroke="currentColor" stroke-width="2">
          <g transform="translate(2.285714, 6.857143)">
            <path d="M10.2857143,1.14285714 L1.14285714,1.14285714"></path>
          </g>
        </g>
      </g>
    </svg>
  `,
    "person-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">
      <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
    </svg>
  `,
    "play-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-play-fill" viewBox="0 0 16 16">
      <path d="m11.596 8.697-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z"></path>
    </svg>
  `,
    "pause-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pause-fill" viewBox="0 0 16 16">
      <path d="M5.5 3.5A1.5 1.5 0 0 1 7 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5zm5 0A1.5 1.5 0 0 1 12 5v6a1.5 1.5 0 0 1-3 0V5a1.5 1.5 0 0 1 1.5-1.5z"></path>
    </svg>
  `,
    radio: `
    <svg part="checked-icon" class="radio__icon" viewBox="0 0 16 16">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g fill="currentColor">
          <circle cx="8" cy="8" r="3.42857143"></circle>
        </g>
      </g>
    </svg>
  `,
    "star-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-star-fill" viewBox="0 0 16 16">
      <path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"/>
    </svg>
  `,
    "x-lg": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
      <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
    </svg>
  `,
    "x-circle-fill": `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-circle-fill" viewBox="0 0 16 16">
      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z"></path>
    </svg>
  `
};
var $c292ca9e30d60186$var$systemLibrary = {
    name: "system",
    resolver: (name)=>{
        if (name in $c292ca9e30d60186$var$icons) return `data:image/svg+xml,${encodeURIComponent($c292ca9e30d60186$var$icons[name])}`;
        return "";
    }
};
var $c292ca9e30d60186$export$3139252f9828970f = $c292ca9e30d60186$var$systemLibrary;


// src/components/icon/library.ts
var $5ac0d73887ae22e0$var$registry = [
    (0, $3a472a6f5dfd296e$export$761783e099ce3526),
    (0, $c292ca9e30d60186$export$3139252f9828970f)
];
var $5ac0d73887ae22e0$var$watchedIcons = [];
function $5ac0d73887ae22e0$export$da63f424a7208010(icon) {
    $5ac0d73887ae22e0$var$watchedIcons.push(icon);
}
function $5ac0d73887ae22e0$export$9e46b25ecab82f0b(icon) {
    $5ac0d73887ae22e0$var$watchedIcons = $5ac0d73887ae22e0$var$watchedIcons.filter((el)=>el !== icon);
}
function $5ac0d73887ae22e0$export$be026de5111f322b(name) {
    return $5ac0d73887ae22e0$var$registry.find((lib)=>lib.name === name);
}
function $5ac0d73887ae22e0$export$a482e04ad60c9b11(name, options) {
    $5ac0d73887ae22e0$export$8faa256e94012669(name);
    $5ac0d73887ae22e0$var$registry.push({
        name: name,
        resolver: options.resolver,
        mutator: options.mutator,
        spriteSheet: options.spriteSheet
    });
    $5ac0d73887ae22e0$var$watchedIcons.forEach((icon)=>{
        if (icon.library === name) icon.setIcon();
    });
}
function $5ac0d73887ae22e0$export$8faa256e94012669(name) {
    $5ac0d73887ae22e0$var$registry = $5ac0d73887ae22e0$var$registry.filter((lib)=>lib.name !== name);
}


// src/components/icon/icon.styles.ts

var $beb756860d1b2c46$export$f0b0874d64866432 = (0, $cc4e6a48b379d1fe$export$dbf350e5966cf602)`
  :host {
    display: inline-block;
    width: 1em;
    height: 1em;
    box-sizing: content-box !important;
  }

  svg {
    display: block;
    height: 100%;
    width: 100%;
  }
`;



// src/internal/watch.ts
function $7807e2622abc63af$export$3db5d71bdb2d5499(propertyName, options) {
    const resolvedOptions = (0, $740df691e57c097e$export$7de063a7aa429f6c)({
        waitUntilFirstUpdate: false
    }, options);
    return (proto, decoratedFnName)=>{
        const { update: update } = proto;
        const watchedProperties = Array.isArray(propertyName) ? propertyName : [
            propertyName
        ];
        proto.update = function(changedProps) {
            watchedProperties.forEach((property)=>{
                const key = property;
                if (changedProps.has(key)) {
                    const oldValue = changedProps.get(key);
                    const newValue = this[key];
                    if (oldValue !== newValue) {
                        if (!resolvedOptions.waitUntilFirstUpdate || this.hasUpdated) this[decoratedFnName](oldValue, newValue);
                    }
                }
            });
            update.call(this, changedProps);
        };
    };
}


// src/styles/component.styles.ts

var $90472bedaa27eb64$export$e1ac0a3ec62d1269 = (0, $cc4e6a48b379d1fe$export$dbf350e5966cf602)`
  :host {
    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  [hidden] {
    display: none !important;
  }
`;




/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $2eef940cba104f66$export$da64fc29f17f9d0e = (t)=>(e, o)=>{
        void 0 !== o ? o.addInitializer(()=>{
            customElements.define(t, e);
        }) : customElements.define(t, e);
    };



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $9e8a2b92768f8b0b$var$o = {
    attribute: !0,
    type: String,
    converter: (0, $58e0238934c743c8$export$7312b35fbf521afb),
    reflect: !1,
    hasChanged: (0, $58e0238934c743c8$export$53a6892c50694894)
}, $9e8a2b92768f8b0b$export$8d623b1670eb40f4 = (t = $9e8a2b92768f8b0b$var$o, e, r)=>{
    const { kind: n, metadata: i } = r;
    let s = globalThis.litPropertyMetadata.get(i);
    if (void 0 === s && globalThis.litPropertyMetadata.set(i, s = new Map), "setter" === n && ((t = Object.create(t)).wrapped = !0), s.set(r.name, t), "accessor" === n) {
        const { name: o } = r;
        return {
            set (r) {
                const n = e.get.call(this);
                e.set.call(this, r), this.requestUpdate(o, n, t, !0, r);
            },
            init (e) {
                return void 0 !== e && this.C(o, void 0, t, e), e;
            }
        };
    }
    if ("setter" === n) {
        const { name: o } = r;
        return function(r) {
            const n = this[o];
            e.call(this, r), this.requestUpdate(o, n, t, !0, r);
        };
    }
    throw Error("Unsupported decorator location: " + n);
};
function $9e8a2b92768f8b0b$export$d541bacb2bda4494(t) {
    return (e, o)=>"object" == typeof o ? $9e8a2b92768f8b0b$export$8d623b1670eb40f4(t, e, o) : ((t, e, o)=>{
            const r = e.hasOwnProperty(o);
            return e.constructor.createProperty(o, t), r ? Object.getOwnPropertyDescriptor(e, o) : void 0;
        })(t, e, o);
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $61fd20d34e44c7b7$export$ca000e230c0caa3e(r) {
    return (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)({
        ...r,
        state: !0,
        attribute: !1
    });
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $9e61451d4946cf68$export$b2b799818fbabcf3(t) {
    return (n, o)=>{
        const c = "function" == typeof n ? n : n[o];
        Object.assign(c, t);
    };
}


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $fdc08805a119d775$export$51987bb50e1f6752 = (e, t, c)=>(c.configurable = !0, c.enumerable = !0, Reflect.decorate && "object" != typeof t && Object.defineProperty(e, t, c), c);


/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $8b301044bff24b22$export$2fa187e846a241c4(e, r) {
    return (n, s, i)=>{
        const o = (t)=>t.renderRoot?.querySelector(e) ?? null;
        if (r) {
            const { get: e, set: r } = "object" == typeof s ? n : i ?? (()=>{
                const t = Symbol();
                return {
                    get () {
                        return this[t];
                    },
                    set (e) {
                        this[t] = e;
                    }
                };
            })();
            return (0, $fdc08805a119d775$export$51987bb50e1f6752)(n, s, {
                get () {
                    let t = e.call(this);
                    return void 0 === t && (t = o(this), (null !== t || this.hasUpdated) && r.call(this, t)), t;
                }
            });
        }
        return (0, $fdc08805a119d775$export$51987bb50e1f6752)(n, s, {
            get () {
                return o(this);
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ let $72d696c06fd57733$var$e;
function $72d696c06fd57733$export$dcd0d083aa86c355(r) {
    return (n, o)=>(0, $fdc08805a119d775$export$51987bb50e1f6752)(n, o, {
            get () {
                return (this.renderRoot ?? ($72d696c06fd57733$var$e ??= document.createDocumentFragment())).querySelectorAll(r);
            }
        });
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $2680b410282ea715$export$163dfc35cc43f240(r) {
    return (n, e)=>(0, $fdc08805a119d775$export$51987bb50e1f6752)(n, e, {
            async get () {
                return await this.updateComplete, this.renderRoot?.querySelector(r) ?? null;
            }
        });
}



/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $2e2cbb54fe59fb33$export$4682af2d9ee91415(o) {
    return (e, n)=>{
        const { slot: r, selector: s } = o ?? {}, c = "slot" + (r ? `[name=${r}]` : ":not([name])");
        return (0, $fdc08805a119d775$export$51987bb50e1f6752)(e, n, {
            get () {
                const t = this.renderRoot?.querySelector(c), e = t?.assignedElements(o) ?? [];
                return void 0 === s ? e : e.filter((t)=>t.matches(s));
            }
        });
    };
}



/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function $f839d719144a5710$export$1bdbe53f9df1b8(n) {
    return (o, r)=>{
        const { slot: e } = n ?? {}, s = "slot" + (e ? `[name=${e}]` : ":not([name])");
        return (0, $fdc08805a119d775$export$51987bb50e1f6752)(o, r, {
            get () {
                const t = this.renderRoot?.querySelector(s);
                return t?.assignedNodes(n) ?? [];
            }
        });
    };
}




var $319a3152dec7ea79$var$_hasRecordedInitialProperties;
var $319a3152dec7ea79$export$6f25236e887097b = class extends (0, $f1ffc5e56da42974$export$3f2f9f5909897157) {
    constructor(){
        super();
        (0, $740df691e57c097e$export$addf369becd23283)(this, $319a3152dec7ea79$var$_hasRecordedInitialProperties, false);
        // Store the constructor value of all `static properties = {}`
        this.initialReflectedProperties = /* @__PURE__ */ new Map();
        Object.entries(this.constructor.dependencies).forEach(([name, component])=>{
            this.constructor.define(name, component);
        });
    }
    emit(name, options) {
        const event = new CustomEvent(name, (0, $740df691e57c097e$export$7de063a7aa429f6c)({
            bubbles: true,
            cancelable: false,
            composed: true,
            detail: {}
        }, options));
        this.dispatchEvent(event);
        return event;
    }
    /* eslint-enable */ static define(name, elementConstructor = this, options = {}) {
        const currentlyRegisteredConstructor = customElements.get(name);
        if (!currentlyRegisteredConstructor) {
            try {
                customElements.define(name, elementConstructor, options);
            } catch (_err) {
                customElements.define(name, class extends elementConstructor {
                }, options);
            }
            return;
        }
        let newVersion = " (unknown version)";
        let existingVersion = newVersion;
        if ("version" in elementConstructor && elementConstructor.version) newVersion = " v" + elementConstructor.version;
        if ("version" in currentlyRegisteredConstructor && currentlyRegisteredConstructor.version) existingVersion = " v" + currentlyRegisteredConstructor.version;
        if (newVersion && existingVersion && newVersion === existingVersion) return;
        console.warn(`Attempted to register <${name}>${newVersion}, but <${name}>${existingVersion} has already been registered.`);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (!(0, $740df691e57c097e$export$18a094aefa070634)(this, $319a3152dec7ea79$var$_hasRecordedInitialProperties)) {
            this.constructor.elementProperties.forEach((obj, prop)=>{
                if (obj.reflect && this[prop] != null) this.initialReflectedProperties.set(prop, this[prop]);
            });
            (0, $740df691e57c097e$export$42432efe6614d3b4)(this, $319a3152dec7ea79$var$_hasRecordedInitialProperties, true);
        }
        super.attributeChangedCallback(name, oldValue, newValue);
    }
    willUpdate(changedProperties) {
        super.willUpdate(changedProperties);
        this.initialReflectedProperties.forEach((value, prop)=>{
            if (changedProperties.has(prop) && this[prop] == null) this[prop] = value;
        });
    }
};
$319a3152dec7ea79$var$_hasRecordedInitialProperties = new WeakMap();
/* eslint-disable */ // @ts-expect-error This is auto-injected at build time.
$319a3152dec7ea79$export$6f25236e887097b.version = "2.20.1";
$319a3152dec7ea79$export$6f25236e887097b.dependencies = {};
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)()
], $319a3152dec7ea79$export$6f25236e887097b.prototype, "dir", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)()
], $319a3152dec7ea79$export$6f25236e887097b.prototype, "lang", 2);





/**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { I: $e799dba0d49694b5$var$t } = (0, $e7d5e6add15542e8$export$8613d1ca9052b22e), $e799dba0d49694b5$var$i = (o)=>o, $e799dba0d49694b5$export$c3825b437cbdea5c = (o)=>null === o || "object" != typeof o && "function" != typeof o, $e799dba0d49694b5$export$80c36ae3cab9881d = {
    HTML: 1,
    SVG: 2,
    MATHML: 3
}, $e799dba0d49694b5$export$6b6d145ec2a44ca9 = (o, t)=>void 0 === t ? void 0 !== o?._$litType$ : o?._$litType$ === t, $e799dba0d49694b5$export$6a0e8de894d2fcca = (o)=>null != o?._$litType$?.h, $e799dba0d49694b5$export$2f448fec17d50a3e = (o)=>void 0 !== o?._$litDirective$, $e799dba0d49694b5$export$f28e31de6a6eaf32 = (o)=>o?._$litDirective$, $e799dba0d49694b5$export$7f431ad0fff82fd9 = (o)=>void 0 === o.strings, $e799dba0d49694b5$var$s = ()=>document.createComment(""), $e799dba0d49694b5$export$291b2338ad9b0b30 = (o, n, e)=>{
    const l = o._$AA.parentNode, d = void 0 === n ? o._$AB : n._$AA;
    if (void 0 === e) {
        const i = l.insertBefore($e799dba0d49694b5$var$s(), d), n = l.insertBefore($e799dba0d49694b5$var$s(), d);
        e = new $e799dba0d49694b5$var$t(i, n, o, o.options);
    } else {
        const t = e._$AB.nextSibling, n = e._$AM, c = n !== o;
        if (c) {
            let t;
            e._$AQ?.(o), e._$AM = o, void 0 !== e._$AP && (t = o._$AU) !== n._$AU && e._$AP(t);
        }
        if (t !== d || c) {
            let o = e._$AA;
            for(; o !== t;){
                const t = $e799dba0d49694b5$var$i(o).nextSibling;
                $e799dba0d49694b5$var$i(l).insertBefore(o, d), o = t;
            }
        }
    }
    return e;
}, $e799dba0d49694b5$export$cb8bf9562088e9f4 = (o, t, i = o)=>(o._$AI(t, i), o), $e799dba0d49694b5$var$m = {}, $e799dba0d49694b5$export$ea70d9dd5965b1c8 = (o, t = $e799dba0d49694b5$var$m)=>o._$AH = t, $e799dba0d49694b5$export$59e9bce518cde500 = (o)=>o._$AH, $e799dba0d49694b5$export$3133b3144bbba267 = (o)=>{
    o._$AR(), o._$AA.remove();
}, $e799dba0d49694b5$export$7f600b8138c094dc = (o)=>{
    o._$AR();
};





var $0a50a3d36b8bd13f$var$CACHEABLE_ERROR = Symbol();
var $0a50a3d36b8bd13f$var$RETRYABLE_ERROR = Symbol();
var $0a50a3d36b8bd13f$var$parser;
var $0a50a3d36b8bd13f$var$iconCache = /* @__PURE__ */ new Map();
var $0a50a3d36b8bd13f$export$ef62a86bf282441 = class extends (0, $319a3152dec7ea79$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.initialRender = false;
        this.svg = null;
        this.label = "";
        this.library = "default";
    }
    /** Given a URL, this function returns the resulting SVG element or an appropriate error symbol. */ async resolveIcon(url, library) {
        var _a;
        let fileData;
        if (library == null ? void 0 : library.spriteSheet) {
            this.svg = (0, $e7d5e6add15542e8$export$c0bb0b647f701bb5)`<svg part="svg">
        <use part="use" href="${url}"></use>
      </svg>`;
            return this.svg;
        }
        try {
            fileData = await fetch(url, {
                mode: "cors"
            });
            if (!fileData.ok) return fileData.status === 410 ? $0a50a3d36b8bd13f$var$CACHEABLE_ERROR : $0a50a3d36b8bd13f$var$RETRYABLE_ERROR;
        } catch (e) {
            return $0a50a3d36b8bd13f$var$RETRYABLE_ERROR;
        }
        try {
            const div = document.createElement("div");
            div.innerHTML = await fileData.text();
            const svg = div.firstElementChild;
            if (((_a = svg == null ? void 0 : svg.tagName) == null ? void 0 : _a.toLowerCase()) !== "svg") return $0a50a3d36b8bd13f$var$CACHEABLE_ERROR;
            if (!$0a50a3d36b8bd13f$var$parser) $0a50a3d36b8bd13f$var$parser = new DOMParser();
            const doc = $0a50a3d36b8bd13f$var$parser.parseFromString(svg.outerHTML, "text/html");
            const svgEl = doc.body.querySelector("svg");
            if (!svgEl) return $0a50a3d36b8bd13f$var$CACHEABLE_ERROR;
            svgEl.part.add("svg");
            return document.adoptNode(svgEl);
        } catch (e) {
            return $0a50a3d36b8bd13f$var$CACHEABLE_ERROR;
        }
    }
    connectedCallback() {
        super.connectedCallback();
        (0, $5ac0d73887ae22e0$export$da63f424a7208010)(this);
    }
    firstUpdated() {
        this.initialRender = true;
        this.setIcon();
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        (0, $5ac0d73887ae22e0$export$9e46b25ecab82f0b)(this);
    }
    getIconSource() {
        const library = (0, $5ac0d73887ae22e0$export$be026de5111f322b)(this.library);
        if (this.name && library) return {
            url: library.resolver(this.name),
            fromLibrary: true
        };
        return {
            url: this.src,
            fromLibrary: false
        };
    }
    handleLabelChange() {
        const hasLabel = typeof this.label === "string" && this.label.length > 0;
        if (hasLabel) {
            this.setAttribute("role", "img");
            this.setAttribute("aria-label", this.label);
            this.removeAttribute("aria-hidden");
        } else {
            this.removeAttribute("role");
            this.removeAttribute("aria-label");
            this.setAttribute("aria-hidden", "true");
        }
    }
    async setIcon() {
        var _a;
        const { url: url, fromLibrary: fromLibrary } = this.getIconSource();
        const library = fromLibrary ? (0, $5ac0d73887ae22e0$export$be026de5111f322b)(this.library) : void 0;
        if (!url) {
            this.svg = null;
            return;
        }
        let iconResolver = $0a50a3d36b8bd13f$var$iconCache.get(url);
        if (!iconResolver) {
            iconResolver = this.resolveIcon(url, library);
            $0a50a3d36b8bd13f$var$iconCache.set(url, iconResolver);
        }
        if (!this.initialRender) return;
        const svg = await iconResolver;
        if (svg === $0a50a3d36b8bd13f$var$RETRYABLE_ERROR) $0a50a3d36b8bd13f$var$iconCache.delete(url);
        if (url !== this.getIconSource().url) return;
        if ((0, $e799dba0d49694b5$export$6b6d145ec2a44ca9)(svg)) {
            this.svg = svg;
            if (library) {
                await this.updateComplete;
                const shadowSVG = this.shadowRoot.querySelector("[part='svg']");
                if (typeof library.mutator === "function" && shadowSVG) library.mutator(shadowSVG);
            }
            return;
        }
        switch(svg){
            case $0a50a3d36b8bd13f$var$RETRYABLE_ERROR:
            case $0a50a3d36b8bd13f$var$CACHEABLE_ERROR:
                this.svg = null;
                this.emit("sl-error");
                break;
            default:
                this.svg = svg.cloneNode(true);
                (_a = library == null ? void 0 : library.mutator) == null || _a.call(library, this.svg);
                this.emit("sl-load");
        }
    }
    render() {
        return this.svg;
    }
};
$0a50a3d36b8bd13f$export$ef62a86bf282441.styles = [
    (0, $90472bedaa27eb64$export$e1ac0a3ec62d1269),
    (0, $beb756860d1b2c46$export$f0b0874d64866432)
];
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $61fd20d34e44c7b7$export$ca000e230c0caa3e)()
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "svg", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)({
        reflect: true
    })
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "name", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)()
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "src", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)()
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "label", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)({
        reflect: true
    })
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "library", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $7807e2622abc63af$export$3db5d71bdb2d5499)("label")
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "handleLabelChange", 1);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $7807e2622abc63af$export$3db5d71bdb2d5499)([
        "name",
        "src",
        "library"
    ])
], $0a50a3d36b8bd13f$export$ef62a86bf282441.prototype, "setIcon", 1);







/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $89f4b43d8a87ecac$export$9ba3b3f20a85bfa = {
    ATTRIBUTE: 1,
    CHILD: 2,
    PROPERTY: 3,
    BOOLEAN_ATTRIBUTE: 4,
    EVENT: 5,
    ELEMENT: 6
}, $89f4b43d8a87ecac$export$99b43ad1ed32e735 = (t)=>(...e)=>({
            _$litDirective$: t,
            values: e
        });
class $89f4b43d8a87ecac$export$befdefbdce210f91 {
    constructor(t){}
    get _$AU() {
        return this._$AM._$AU;
    }
    _$AT(t, e, i) {
        this._$Ct = t, this._$AM = e, this._$Ci = i;
    }
    _$AS(t, e) {
        return this.update(t, e);
    }
    update(t, e) {
        return this.render(...e);
    }
}


/**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const $167efb3ba91542e7$export$56cc687933817664 = (0, $89f4b43d8a87ecac$export$99b43ad1ed32e735)(class extends (0, $89f4b43d8a87ecac$export$befdefbdce210f91) {
    constructor(t){
        if (super(t), t.type !== (0, $89f4b43d8a87ecac$export$9ba3b3f20a85bfa).ATTRIBUTE || "class" !== t.name || t.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
    }
    render(t) {
        return " " + Object.keys(t).filter((s)=>t[s]).join(" ") + " ";
    }
    update(s, [i]) {
        if (void 0 === this.st) {
            this.st = new Set, void 0 !== s.strings && (this.nt = new Set(s.strings.join(" ").split(/\s/).filter((t)=>"" !== t)));
            for(const t in i)i[t] && !this.nt?.has(t) && this.st.add(t);
            return this.render(i);
        }
        const r = s.element.classList;
        for (const t of this.st)t in i || (r.remove(t), this.st.delete(t));
        for(const t in i){
            const s = !!i[t];
            s === this.st.has(t) || this.nt?.has(t) || (s ? (r.add(t), this.st.add(t)) : (r.remove(t), this.st.delete(t)));
        }
        return 0, $e7d5e6add15542e8$export$9c068ae9cc5db4e8;
    }
});






var $e593d30aeba53cc6$export$ada524cc60438dd5 = class extends (0, $319a3152dec7ea79$export$6f25236e887097b) {
    constructor(){
        super(...arguments);
        this.localize = new (0, $b8c5b97ae6a60640$export$b1a2fed5bb41b893)(this);
        this.open = false;
        this.disabled = false;
    }
    firstUpdated() {
        this.body.style.height = this.open ? "auto" : "0";
        if (this.open) this.details.open = true;
        this.detailsObserver = new MutationObserver((changes)=>{
            for (const change of changes)if (change.type === "attributes" && change.attributeName === "open") {
                if (this.details.open) this.show();
                else this.hide();
            }
        });
        this.detailsObserver.observe(this.details, {
            attributes: true
        });
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        (_a = this.detailsObserver) == null || _a.disconnect();
    }
    handleSummaryClick(event) {
        event.preventDefault();
        if (!this.disabled) {
            if (this.open) this.hide();
            else this.show();
            this.header.focus();
        }
    }
    handleSummaryKeyDown(event) {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            if (this.open) this.hide();
            else this.show();
        }
        if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
            event.preventDefault();
            this.hide();
        }
        if (event.key === "ArrowDown" || event.key === "ArrowRight") {
            event.preventDefault();
            this.show();
        }
    }
    async handleOpenChange() {
        if (this.open) {
            this.details.open = true;
            const slShow = this.emit("sl-show", {
                cancelable: true
            });
            if (slShow.defaultPrevented) {
                this.open = false;
                this.details.open = false;
                return;
            }
            await (0, $eb4d5de33b0d3712$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $be66bbac00f5dd56$export$b1aed5dec0c2d368)(this, "details.show", {
                dir: this.localize.dir()
            });
            await (0, $eb4d5de33b0d3712$export$3b755839a54e1bb0)(this.body, (0, $eb4d5de33b0d3712$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.emit("sl-after-show");
        } else {
            const slHide = this.emit("sl-hide", {
                cancelable: true
            });
            if (slHide.defaultPrevented) {
                this.details.open = true;
                this.open = true;
                return;
            }
            await (0, $eb4d5de33b0d3712$export$ad12f740028ccbea)(this.body);
            const { keyframes: keyframes, options: options } = (0, $be66bbac00f5dd56$export$b1aed5dec0c2d368)(this, "details.hide", {
                dir: this.localize.dir()
            });
            await (0, $eb4d5de33b0d3712$export$3b755839a54e1bb0)(this.body, (0, $eb4d5de33b0d3712$export$783a9b5bf095072a)(keyframes, this.body.scrollHeight), options);
            this.body.style.height = "auto";
            this.details.open = false;
            this.emit("sl-after-hide");
        }
    }
    /** Shows the details. */ async show() {
        if (this.open || this.disabled) return void 0;
        this.open = true;
        return (0, $7eaf42424ddc4bed$export$6608ab6fe9313967)(this, "sl-after-show");
    }
    /** Hides the details */ async hide() {
        if (!this.open || this.disabled) return void 0;
        this.open = false;
        return (0, $7eaf42424ddc4bed$export$6608ab6fe9313967)(this, "sl-after-hide");
    }
    render() {
        const isRtl = this.localize.dir() === "rtl";
        return (0, $e7d5e6add15542e8$export$c0bb0b647f701bb5)`
      <details
        part="base"
        class=${(0, $167efb3ba91542e7$export$56cc687933817664)({
            details: true,
            "details--open": this.open,
            "details--disabled": this.disabled,
            "details--rtl": isRtl
        })}
      >
        <summary
          part="header"
          id="header"
          class="details__header"
          role="button"
          aria-expanded=${this.open ? "true" : "false"}
          aria-controls="content"
          aria-disabled=${this.disabled ? "true" : "false"}
          tabindex=${this.disabled ? "-1" : "0"}
          @click=${this.handleSummaryClick}
          @keydown=${this.handleSummaryKeyDown}
        >
          <slot name="summary" part="summary" class="details__summary">${this.summary}</slot>

          <span part="summary-icon" class="details__summary-icon">
            <slot name="expand-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
            <slot name="collapse-icon">
              <sl-icon library="system" name=${isRtl ? "chevron-left" : "chevron-right"}></sl-icon>
            </slot>
          </span>
        </summary>

        <div class="details__body" role="region" aria-labelledby="header">
          <slot part="content" id="content" class="details__content"></slot>
        </div>
      </details>
    `;
    }
};
$e593d30aeba53cc6$export$ada524cc60438dd5.styles = [
    (0, $90472bedaa27eb64$export$e1ac0a3ec62d1269),
    (0, $b050f32796b07fe6$export$e0460a263d3b7bef)
];
$e593d30aeba53cc6$export$ada524cc60438dd5.dependencies = {
    "sl-icon": (0, $0a50a3d36b8bd13f$export$ef62a86bf282441)
};
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $8b301044bff24b22$export$2fa187e846a241c4)(".details")
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "details", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $8b301044bff24b22$export$2fa187e846a241c4)(".details__header")
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "header", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $8b301044bff24b22$export$2fa187e846a241c4)(".details__body")
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "body", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $8b301044bff24b22$export$2fa187e846a241c4)(".details__expand-icon-slot")
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "expandIconSlot", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "open", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)()
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "summary", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $9e8a2b92768f8b0b$export$d541bacb2bda4494)({
        type: Boolean,
        reflect: true
    })
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "disabled", 2);
(0, $740df691e57c097e$export$85c93885f16e8446)([
    (0, $7807e2622abc63af$export$3db5d71bdb2d5499)("open", {
        waitUntilFirstUpdate: true
    })
], $e593d30aeba53cc6$export$ada524cc60438dd5.prototype, "handleOpenChange", 1);
(0, $be66bbac00f5dd56$export$6e92ecdbe15fda0b)("details.show", {
    keyframes: [
        {
            height: "0",
            opacity: "0"
        },
        {
            height: "auto",
            opacity: "1"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});
(0, $be66bbac00f5dd56$export$6e92ecdbe15fda0b)("details.hide", {
    keyframes: [
        {
            height: "auto",
            opacity: "1"
        },
        {
            height: "0",
            opacity: "0"
        }
    ],
    options: {
        duration: 250,
        easing: "linear"
    }
});


// src/components/details/details.ts
var $8dac343549e15148$export$991e1c3cf581681b = (0, $e593d30aeba53cc6$export$ada524cc60438dd5);
(0, $e593d30aeba53cc6$export$ada524cc60438dd5).define("sl-details");





















/**
 * Initialize accordions
 *
 * Loop through the accordion blocks and add event listeners to show/hide the accordion content
 *
 * @return {void}
 */ function $94ed26dd77b59d04$var$initAccordions() {
    const accordions = document.querySelectorAll('.pdm-accordion__content');
    // Close all other details when one is shown
    accordions.forEach((accordion)=>{
        accordion.addEventListener('sl-show', (event)=>{
            if (event.target.localName === 'sl-details') [
                ...accordion.querySelectorAll('sl-details')
            ].map((details)=>details.open = event.target === details);
        });
    });
}
document.addEventListener('DOMContentLoaded', ()=>{
    $94ed26dd77b59d04$var$initAccordions();
});

})();
//# sourceMappingURL=accordion-block.js.map
